import MembershipPaymentMethodConfirmation from './MembershipPaymentMethodConfirmation';

export default MembershipPaymentMethodConfirmation;
